import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
    strict: false,
    plugins: [],
    state: {
        linkCode: null,
        place: {
            logo: null,
            color: null,
            name: null,
            slug: null,
        },
        form: {
            active: null,
            askBirthdate: null,
            askEmail: null,
            askLastName: null,
            askName: null,
            askPhone: null,
            custom_css: null,
            couponLifeTime: null,
            couponTooRecent: null,
            description: null,
            id: null,
            name: null,
            places_id: null,
            sms_template: null,
            steps: [],
            title: null,
            timeBetweenAnswers: null,
        },
        answers: {},
    },
    mutations: {
        setLinkCode(state, newLinkCode) {
            state.linkCode = newLinkCode;
        },
        setPlace(state, place) {
            state.place = place;
        },
        setForm(state, form) {
            state.form = form;
        },
        setAnswer(state, { questionId, value }) {
            Vue.set(state.answers, questionId, value);
        },
        clearAnswers(state) {
            state.answers = {};
        },
    },
    getters: {
        getAnswers(state) {
            return state.answers;
        },
        getAnswer: (state) => (questionId) => {
            return state.answers[questionId];
        },
    },
});

export default store;
